<script>
    import axios from 'axios';
    import Compressor from 'compressorjs';

    const domain = K_DOMAIN;

    let language = false; //true表示中文，false为英文

    let configs = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    };

    let fileConfigs = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };

    function toggleLoader(type) {
        document.getElementById('loader-overlay').style.display = type ? 'block' : 'none';
    }

    function requestParams(obj) {
        let rangeArr = [],
            params = '';
        if (obj && typeof obj === 'object') {
            if (rangeArr.length === 0) {
                rangeArr.push('?')
            }
            for (let i in obj) {
                if (obj.hasOwnProperty(i)) {
                    let value = obj[i];
                    if (Object.prototype.toString.call(value) === '[object Array]') {
                        if (value !== []) {
                            for (let j in value) {
                                rangeArr.push(i);
                                rangeArr.push('=');
                                rangeArr.push(value[j]);
                                rangeArr.push('&');
                            }
                        }
                    } else {
                        if (value !== '') {
                            rangeArr.push(i);
                            rangeArr.push('=');
                            rangeArr.push(value);
                            rangeArr.push('&');
                        }
                    }
                }
            }
            params = rangeArr.join('').replace(/&$/, '');
            return params
        }
    }

    function httpPost(url, params) {
        toggleLoader(true);
        let paramsString = params ? requestParams(params) : "";
        return new Promise((resolve, reject) => {
            axios
                .post(domain + url + paramsString, "", configs)
                .then(
                    (res) => {
                        toggleLoader(false);
                        resolve(res.data)
                    },
                    (err) => {
                        toggleLoader(false);
                        reject(err.response.data)
                    }
                )
        })
    }

    function httpFilePost(url, data) {
        toggleLoader(true);
        return new Promise((resolve, reject) => {
            axios
                .post(domain + url, data, fileConfigs)
                .then(
                    (res) => {
                        toggleLoader(false);
                        resolve(res.data)
                    },
                    (err) => {
                        toggleLoader(false);
                        reject(err.response.data)
                    }
                )
        })
    }

    function isNumber(value) {
        return !Number.isNaN(Number(value))
    }

    export default {
        httpFilePost,
        httpPost,
        isNumber,
        language,
        toggleLoader,
        Compressor,
        axios
    }
</script>
